import React, { createContext, useContext, useState } from "react";
import { number } from "../../config";

export const ContentManagerSystemContext = createContext({
  selectedGridItem: {},
  setSelectedGridItem: () => {},
  gridSelection: {},
  setGridSelection: () => {},
  setFiles: () => {},
  contextMenuView: false,
  setContextMenuView: () => {},
  menuOffSet: { left: 0, top: 0 },
  setMenuOffSet: () => {},
  editDialogView: false,
  setEditDialogView: () => {},
  deleteDialogView: false,
  setDeleteDialogView: () => {},
  projectName: "",
  setProjectName: () => {},
  selectedFile: {},
  setSelectedFile: () => {},
  selectedPdfFile: {},
  setSelectedPdfFile: () => {},
  selectedItems: [],
  setSelectedItems: () => {},
  selectAll: false,
  setSelectAll: () => {},
  selectedItemPath: "",
  setSelectedItemPath: () => {},
  missingParents: [],
  setMissingParents: () => {},
  missingParents: 0,
  setMissingParents: () => {},
  pageNumber: 1,
  setPageNumber: () => {},
  isLastattachment: 1,
  setIsLastAttachment: () => {},
  fileInfoWidth: "",
  setFileInfoWidth: () => {},
});

export const ContentManagerSystemContextProvider = ({ children }) => {
  const [selectedGridItem, setSelectedGridItem] = useState({});
  const [gridSelection, setGridSelection] = useState({});
  const [contextMenuView, setContextMenuView] = useState(false);
  const [menuOffSet, setMenuOffSet] = useState({ left: 0, top: 0 });
  const [editDialogView, setEditDialogView] = useState(false);
  const [restoreDialogView, setRestoreDialogView] = useState(false);
  const [deleteDialogView, setDeleteDialogView] = useState(false);

  const [projectName, setProjectName] = useState("");
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [selectedPdfFile, setSelectedPdfFile] = React.useState(null);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [selectedItemPath, setSelectedItemPath] = React.useState(false);
  const [missingParents, setMissingParents] = React.useState([]);
  const [pageNumber, setPageNumber] = React.useState(1);
  const [isLastattachment, setIsLastAttachment] = React.useState(false);
  const [fileInfoWidth, setFileInfoWidth] = useState(number.FOUR_HUNDRED_NINTY);

  const value = {
    selectedGridItem,
    setSelectedGridItem,
    gridSelection,
    setGridSelection,
    contextMenuView,
    setContextMenuView,
    menuOffSet,
    setMenuOffSet,
    editDialogView,
    setEditDialogView,
    deleteDialogView,
    setDeleteDialogView,
    projectName,
    setProjectName,
    restoreDialogView,
    setRestoreDialogView,
    selectedFile,
    setSelectedFile,
    selectedPdfFile,
    setSelectedPdfFile,
    selectedItems,
    setSelectedItems,
    selectAll,
    setSelectAll,
    selectedItemPath,
    setSelectedItemPath,
    missingParents,
    setMissingParents,
    pageNumber,
    setPageNumber,
    isLastattachment,
    setIsLastAttachment,
    fileInfoWidth,
    setFileInfoWidth,
  };

  return <ContentManagerSystemContext.Provider value={value}>{children}</ContentManagerSystemContext.Provider>;
};

/** A custom hook to access the content manager system context */
export const useContentManagerSystemContext = () => {
  return useContext(ContentManagerSystemContext);
};
